import { Droplet, Dna, Moon, Sunrise, Sprout, Gauge } from 'lucide-react';

// Shared between the desktop white-card and mobile glass-chip renderings of
// "Trained on female biology". Multi-select on purpose — a user can have
// more than one mode active at once (period tracking + perimenopause, etc.),
// unlike an earlier single "active mode" exploration.
export const HEALTH_MODES = [
  { label: 'Period syncing', Icon: Droplet, active: true },
  { label: 'PMOS/PCOS', Icon: Dna, active: true },
  { label: 'Perimenopause', Icon: Moon, active: false },
  { label: 'Postmenopause', Icon: Sunrise, active: false },
  { label: 'Conception & fertility', Icon: Sprout, active: false },
  { label: 'Hypothyroidism', Icon: Gauge, active: false },
];
